module.exports = __webpack_public_path__ + "img/article4.bd45c438.jpg";